import { createSlice, current, type PayloadAction } from "@reduxjs/toolkit";

import { createAppThunk, type IRes } from "store/modules/common";
import Http from "commons/Http";
import type { IPageInfo } from "pages/notice/store/NoticeVo";
import {
  ActiveType,
  taxStatus,
  type CalculateActiveTab,
  type CalculateContentSubTab,
  type CalculateMediaSubTab,
  type CalculatePartnersSubTab,
  type ICalculateTotalTopInfoVo,
  type IContentsChanneGridDetail,
  type IContentsChannelGirdListVo,
  type IContentsChanneTotalVo,
  type IExpectListVo,
  type IGridRowUpdateData,
  type IMediaExcelListFetc,
  type IResSalaesList,
  type IResTotalCalculateData,
  type ISettlementListVo,
  payStatus,
  approvalStatus,
} from "./CalculateVo";
import type { IAlarmFetch } from "components/popup/alarmtalk/AlarmtalkVo";
import { returnRes } from "commons/store/common";

// 이름 설정
const name = "calculate";

export const calculateTotalResult = (
  list: IContentsChannelGirdListVo[],
  key: keyof IContentsChanneGridDetail,
): number => {
  return list.reduce((acc, cur) => {
    return acc + cur.list.reduce((sum, item) => sum + (Number(item[key]) || 0), 0);
  }, 0);
};

export interface ICalculate {
  activeTab?: CalculateActiveTab;
  subTab: { [key: string]: CalculateContentSubTab | CalculateMediaSubTab | CalculatePartnersSubTab };
  searchMonth?: { [key: string]: number };
  selectChannelList?: { [key: string]: { id: number; text: string }[] };

  contents: {
    [key: string]: {
      list: IContentsChannelGirdListVo[];
      viewList: IContentsChannelGirdListVo[];
      total?: IContentsChanneTotalVo;
      info?: ICalculateTotalTopInfoVo;
      detailList?: IContentsChanneGridDetail[];
      // detailList?: { [key: string]: { list: { [key: string]: IContentsChanneGridDetail } } };
      saveFlag?: boolean;
    };
  };

  //예상수익 관련
  expect: {
    pageInfo?: IPageInfo;
    list: IExpectListVo[];
  };
  //정산금 관련
  settlement: {
    pageInfo?: IPageInfo;
    list: ISettlementListVo[];
    excelViewList?: ISettlementListVo[];
  };
}

// MSN 엑셀 불러오기
export const apiPMsnExcelSave = createAppThunk<IResTotalCalculateData, undefined>(
  `${name}/apiPMsnExcelSave`,
  async (_, thunkApi) => {
    const tab = thunkApi.getState().calculate.activeTab;
    const subTab = thunkApi.getState().calculate.subTab[tab!];
    const searchMonth = thunkApi.getState().calculate.searchMonth && thunkApi.getState().calculate.searchMonth![tab!];

    const month = searchMonth
      ? searchMonth
      : new Date().getMonth() === 0
      ? new Date().getMonth() + 1
      : new Date().getMonth();

    const paramMonth = Number(month) >= 10 ? String(month) : `0${Number(month)}`;
    const year = thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`]
      ? Number(thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`])
      : new Date().getFullYear();

    const form = new FormData();
    form.append("type", subTab === "msn" ? `${subTab.toUpperCase()}_CP` : `VIEWUS_${subTab.toUpperCase()}`);
    form.append("year", String(year));
    form.append("month", paramMonth);

    if (thunkApi.getState().ui!.inputFile![`${tab}_${subTab}_excel`].file) {
      form.append(
        "file",
        thunkApi.getState().ui!.inputFile![`${tab}_${subTab}_excel`].file!,
        thunkApi.getState().ui!.inputFile![`${tab}_${subTab}_excel`].file!.name,
      );
    }

    const res = await Http.post<IRes<IResTotalCalculateData>>(`settlement/excel/calc`, form, {
      headers: { "content-type": "multipart/form-data" },
    });
    if (res.data.content) {
      console.log(res.data.content);
      // thunkApi.dispatch(rdxSetCalculateGridTotalData(res.data.content.total));
      // thunkApi.dispatch(rdxSetCalculateGridListData(res.data.content.list));
      // thunkApi.dispatch(rdxSetCalculateTotalInfo(res.data.content.info));
      // thunkApi.dispatch(rdxSetCalculateSaveFlag(true));
    }

    return res.data;
  },
);

// 정산 - 정산 자동화 리스트(초기화면 리스트)
export const apiGcalculateTotalList = createAppThunk<IResTotalCalculateData, { tab: string; page: number }>(
  `${name}/apiGcalculateTotalList`,
  async (param, thunkApi) => {
    const tab = param.tab;
    const subTab = thunkApi.getState().calculate.subTab[tab!];
    const searchMonth = thunkApi.getState().calculate.searchMonth && thunkApi.getState().calculate.searchMonth![tab!];

    const selectChannelList = thunkApi.getState().calculate.selectChannelList;
    const idList = selectChannelList ? selectChannelList[tab] || [] : [];
    const month = searchMonth
      ? searchMonth
      : new Date().getMonth() === 0
      ? new Date().getMonth() + 1
      : new Date().getMonth();

    const paramMonth = Number(month) >= 10 ? Number(month) : `0${Number(month)}`;
    const year = thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`]
      ? Number(thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`])
      : new Date().getFullYear();

    const date = `${year}-${paramMonth}`;
    const params = {
      date: date,
      // date: "2023-12",
      type:
        tab === ActiveType.CP
          ? subTab === "msn"
            ? `${subTab.toUpperCase()}_CP`
            : `VIEWUS_${subTab.toUpperCase()}`
          : tab === ActiveType.PN
          ? subTab === "partners"
            ? subTab.toUpperCase()
            : `VIEWUS_${subTab.toUpperCase()}`
          : "MEDIA",
      serviceType: tab,
      idList: idList.length > 0 ? idList.map(i => i.id) : idList,
      taxStatus: thunkApi.getState().ui.selectbox?.["calculate_tax_filter"]
        ? thunkApi.getState().ui.selectbox?.["calculate_tax_filter"]
        : null,
      payStatus: thunkApi.getState().ui.selectbox?.["calculate_pay_filter"]
        ? thunkApi.getState().ui.selectbox?.["calculate_pay_filter"]
        : null,
      approvalStatus: thunkApi.getState().ui.selectbox?.["calculate_approval_filter"]
        ? thunkApi.getState().ui.selectbox?.["calculate_approval_filter"]
        : null,
    };

    // uiux 리뉴얼 전 API -> settlement/calc
    const res = await Http.get<IRes<IResTotalCalculateData>>(`v3/settlement`, {
      params: params,
    });

    if (res.data.content) {
      thunkApi.dispatch(rdxSetCalculateTotalInfo(res.data.content.info));
      thunkApi.dispatch(rdxSetCalculateGridTotalData(res.data.content.total));
      thunkApi.dispatch(rdxSetCalculateGridListData(res.data.content.list));
    }

    return res.data;
  },
);

// 정산 - 서브 탭 -> 예상수익
export const apiGexpectDataList = createAppThunk<{ data: IResSalaesList }, IPageInfo>(
  `${name}/apiGexpectDataList`,
  async (param, thunkApi) => {
    const tab = thunkApi.getState().calculate.activeTab;
    const params = {
      date: thunkApi.getState().ui.inputText?.[`${tab}_Calendar_Date`],
      size: 20,
      page: param.page,
      serviceType: tab,
    };
    const res = await Http.get<IRes<{ data: IResSalaesList }>>(`settlement/expect`, { params: params });
    if (res.data.content) {
      thunkApi.dispatch(
        rdxSetExpectListPageInfo({
          page: res.data.content.data.page_info!.page,
          size: 20,
          total_elements: res.data.content.data.page_info!.total_elements,
          totalPage: Math.ceil(res.data.content.data.page_info!.total_elements! / params.size),
        }),
      );
      thunkApi.dispatch(rdxSetExpectListData(res.data.content.data.list as IExpectListVo[]));
    }

    return res.data;
  },
);

// 정산 - 서브 탭 - 정산금
export const apiGsettlementDataList = createAppThunk<{ data: IResSalaesList }, IPageInfo>(
  `${name}/apiGsettlementDataList`,
  async (param, thunkApi) => {
    const tab = thunkApi.getState().calculate.activeTab;
    const subTab = thunkApi.getState().calculate.subTab[tab!];
    const searchMonth = thunkApi.getState().calculate.searchMonth && thunkApi.getState().calculate.searchMonth![tab!];

    const month = searchMonth
      ? searchMonth
      : new Date().getMonth() === 0
      ? new Date().getMonth() + 1
      : new Date().getMonth();

    const paramMonth = Number(month) >= 10 ? Number(month) : `0${Number(month)}`;
    const year = thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`]
      ? Number(thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`])
      : new Date().getFullYear();

    const params = {
      date: `${year}-${paramMonth}`,
      size: 20,
      page: param.page,
      serviceType: tab,
    };
    const res = await Http.get<IRes<{ data: IResSalaesList }>>(`settlement`, { params: params });
    if (res.data.content) {
      thunkApi.dispatch(
        rdxSetSettlementListPageInfo({
          page: res.data.content.data.page_info!.page,
          size: 20,
          total_elements: res.data.content.data.page_info!.total_elements,
          totalPage: Math.ceil(res.data.content.data.page_info!.total_elements! / 20),
        }),
      );
      thunkApi.dispatch(rdxSetSettlementListData(res.data.content.data.list as ISettlementListVo[]));
    }

    return res.data;
  },
);

// 정산 -> 리스트 -> 저장버튼 (사용자에게 보여지는 리스트X)
export const apiPcalculateViewListSave = createAppThunk<IResTotalCalculateData, undefined>(
  `${name}/apiPcalculateViewListSave`,
  async (_, thunkApi) => {
    const tab = thunkApi.getState().calculate.activeTab;
    const subTab = thunkApi.getState().calculate.subTab[tab!];
    const searchMonth = thunkApi.getState().calculate.searchMonth && thunkApi.getState().calculate.searchMonth![tab!];

    const month = searchMonth
      ? searchMonth
      : new Date().getMonth() === 0
      ? new Date().getMonth() + 1
      : new Date().getMonth();

    const paramMonth = Number(month) >= 10 ? Number(month) : `0${Number(month)}`;
    const year = thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`]
      ? Number(thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`])
      : new Date().getFullYear();

    const params = {
      date: `${year}-${paramMonth}`,
      // date: `2023-12`,
      type:
        tab === ActiveType.CP
          ? subTab === "msn"
            ? `${subTab.toUpperCase()}_CP`
            : `VIEWUS_${subTab.toUpperCase()}`
          : tab === ActiveType.PN
          ? subTab === "partners"
            ? subTab.toUpperCase()
            : `VIEWUS_${subTab.toUpperCase()}`
          : "MEDIA",
      service_type: tab,
      list: thunkApi.getState().calculate.contents[subTab as string].viewList,
    };
    // const res = await Http.post<IRes<IResTotalCalculateData>>(`settlement/calc`, params);
    const res = await Http.post<IRes<IResTotalCalculateData>>(`v3/settlement`, params);
    if (res) {
      thunkApi.dispatch(rdxSetCalculateSaveFlag(true));
    }

    return res.data;
  },
);

// 정산 -> 리스트 -> 정산내역 발행
export const apiPcalculatePublish = createAppThunk(`${name}/apiPcalculatePublish`, async (_, thunkApi) => {
  const tab = thunkApi.getState().calculate.activeTab;
  const subTab = thunkApi.getState().calculate.subTab[tab!];
  const searchMonth = thunkApi.getState().calculate.searchMonth && thunkApi.getState().calculate.searchMonth![tab!];

  const month = searchMonth
    ? searchMonth
    : new Date().getMonth() === 0
    ? new Date().getMonth() + 1
    : new Date().getMonth();

  const paramMonth = Number(month) >= 10 ? Number(month) : `0${Number(month)}`;
  const year = thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`]
    ? Number(thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`])
    : new Date().getFullYear();

  const params = {
    date: `${year}-${paramMonth}`,
    type:
      tab === ActiveType.CP
        ? subTab === "msn"
          ? `${subTab.toUpperCase()}_CP`
          : `VIEWUS_${subTab.toUpperCase()}`
        : tab === ActiveType.PN
        ? subTab === "partners"
          ? subTab.toUpperCase()
          : `VIEWUS_${subTab.toUpperCase()}`
        : "MEDIA",
    service_type: tab,
  };
  const res = await Http.post(`settlement/calc/issue`, params);
  if (res) {
    thunkApi.dispatch(rdxSetCalculateSaveFlag());
  }

  return res.data;
});

// 알림톡 보내기
export const apiPsendAlarm = createAppThunk<undefined, IAlarmFetch>(`${name}/apiPsendAlarm`, async param => {
  // const apiUrl = param.list_type === "CON" ? "consalad/sales/alarm" : "admin/revenue/alarm";
  const res = await Http.post("admin/alarm", { template: param.template, code_list: param.code_list });
  return res.data;
});

// 정산 > Excel 다운로드
export const apiGdownloadExcel = createAppThunk(`${name}/apiGdownloadExcel`, async (_, thunkApi) => {
  const tab = thunkApi.getState().calculate.activeTab;
  const subTab = thunkApi.getState().calculate.subTab[tab!];
  const searchMonth = thunkApi.getState().calculate.searchMonth && thunkApi.getState().calculate.searchMonth![tab!];

  const month = searchMonth
    ? searchMonth
    : new Date().getMonth() === 0
    ? new Date().getMonth() + 1
    : new Date().getMonth();

  const params = {
    year: thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`]
      ? Number(thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`])
      : new Date().getFullYear(),
    month: month,
    serviceType: tab,
  };

  const res = await Http.get(`settlement/csv`, {
    params: params,
  });
  if (res.data) {
    const url = window.URL.createObjectURL(new Blob(["\ufeff" + res.data], { type: "text/csv" }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${params.year}${Number(params.month) < 10 ? `0${Number(params.month)}` : Number(params.month)}_매출정산금.csv`,
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  return returnRes();
});

// 음원,영상 탭 > 정산금 탭 > [정산내역 발행]버튼 클릭 시 매출정보 저장
export const apiPpublishMediaExcel = createAppThunk<undefined, IMediaExcelListFetc>(
  `${name}/apiPpublishMediaExcel`,
  async (_, thunkApi) => {
    const tab = thunkApi.getState().calculate.activeTab;
    const subTab = thunkApi.getState().calculate.subTab[tab!];
    const searchMonth = thunkApi.getState().calculate.searchMonth && thunkApi.getState().calculate.searchMonth![tab!];
    const month = searchMonth
      ? searchMonth
      : new Date().getMonth() === 0
      ? new Date().getMonth() + 1
      : new Date().getMonth();

    const param = {
      year: Number(thunkApi.getState().ui?.selectbox?.[`calculate_${tab}_${subTab}_search_year`]),
      month: month,
      service_type: tab,
      data: thunkApi.getState().calculate.settlement.excelViewList!.map(i => ({
        channel_id: i.channel_id,
        views: i.page_count,
        amount: i.settlement,
      })),
    };

    const res = await Http.post(`settlement/csv`, param);

    if (res.data) {
      //CSV 불러왔던 데이터 삭제
      thunkApi.dispatch(rdxResetSettlementExcelViewList());
    }
    return res.data;
  },
);

const CalculateSlice = createSlice({
  name,
  initialState: {
    activeTab: "PROVIDER",
    subTab: {
      PROVIDER: "msn",
      MEDIA: "sales",
      PARTNERS: "partners",
    },
    contents: {
      cp: { list: [], viewList: [] },
      pp: { list: [], viewList: [] },
      msn: { list: [], viewList: [] },
      partners: { list: [], viewList: [] },
      sales: { list: [], viewList: [] }, //미디어 일때만 사용
    },
    expect: {
      list: [],
    },
    settlement: {
      list: [],
    },
  } as ICalculate,
  reducers: {
    rdxSetActiveTab(state: ICalculate, action: PayloadAction<CalculateActiveTab>) {
      state.activeTab = action.payload;
    },
    rdxSetSubTab(
      state: ICalculate,
      action: PayloadAction<CalculateContentSubTab | CalculateMediaSubTab | CalculatePartnersSubTab>,
    ) {
      state.subTab[state.activeTab!] = action.payload;
      delete state.selectChannelList;
      delete state.searchMonth;
    },
    rdxSetSearchMonthTab(state: ICalculate, action: PayloadAction<number>) {
      state.searchMonth = {
        [state.activeTab!]: action.payload,
      };
    },
    //정산 - 선택한 채널 리스트
    rdxSetSelectChannelList(state: ICalculate, action: PayloadAction<{ id: number; text: string }>) {
      const empty = state.selectChannelList && state.selectChannelList[state.activeTab!] ? false : true;
      const list = empty ? [] : state.selectChannelList![`${state.activeTab}`].map(i => i.id);

      if (!list.includes(action.payload.id)) {
        if (empty) {
          state.selectChannelList = {
            [state.activeTab!]: [
              {
                id: action.payload.id,
                text: action.payload.text,
              },
            ],
          };
        } else {
          state.selectChannelList![`${state.activeTab}`] = state.selectChannelList![`${state.activeTab}`].concat(
            action.payload,
          );
        }
      }
    },
    //정산 - 채널리스트 엑스버튼 클릭 시
    rdxRemoveSelectChannelList(state: ICalculate, action: PayloadAction<number>) {
      const list = state.selectChannelList![`${state.activeTab}`];
      const removeTarget = list!.filter(item => {
        return item.id !== action.payload;
      });
      state.selectChannelList![`${state.activeTab}`] = removeTarget;
    },

    //정산 그리드 리스트 토탈 정보
    rdxSetCalculateTotalInfo(state: ICalculate, action: PayloadAction<ICalculateTotalTopInfoVo>) {
      state.contents[state.subTab[state.activeTab!]].info! = action.payload;
    },

    //정산 정보 텍스트 표시
    rdxSetCalculateGridTotalData(state: ICalculate, action: PayloadAction<IContentsChanneTotalVo>) {
      state.contents[state.subTab[state.activeTab!]].total! = action.payload;
    },

    //정산자동화 (정산 진입 페이지 리스트)
    rdxSetCalculateGridListData(state: ICalculate, action: PayloadAction<IContentsChannelGirdListVo[]>) {
      const subTab = state.subTab[state.activeTab!];
      state.contents[subTab].list = action.payload;
      state.contents[subTab].viewList = action.payload;
      state.contents[subTab].detailList = action.payload.map(i => i.list).flat();
    },
    //정산자동화 -> grid row input 수정 할때 마다 호출 할 함수
    // * cp 정산 = 모든 calculate 합
    // * 최종 이익금 = (모든 sales 합) - (모든 calculate 합)
    // * cp 정산금(settlement) = origin_settlement * (ratio/100)
    // * 최종 합계(calculate) = settlement + add_settlement
    // * 단가(unit_price) = calculate / pageView (소수 2번째 까지)
    rdxSetCalculateGridRowUpdate(state: ICalculate, action: PayloadAction<IGridRowUpdateData>) {
      const subTab = state.subTab[state.activeTab!];
      const total = state.contents[subTab].total;
      const viewList = state.contents[subTab].viewList;

      const index = viewList.findIndex(i => i.user_id === action.payload.user_id);

      if (action.payload.code) {
        const rowNum = action.payload.row_num ? action.payload.row_num : 0;
        const detail = state.contents[subTab].viewList![index].list[rowNum];

        if (action.payload.value !== undefined) {
          if (action.payload.type === "ratio" || action.payload.type === "add") {
            if (action.payload.type === "ratio") {
              detail.ratio = Number(action.payload.value);
            } else {
              detail.add_settlement = action.payload.value
                ? Number(action.payload.value)
                : detail.add_settlement
                ? detail.add_settlement
                : 0;
            }
            detail.settlement = Math.round(detail.origin_settlement! * (detail.ratio! / 100));
            detail.calculate = detail.settlement + (detail.add_settlement ? detail.add_settlement : 0);
            detail.unit_price =
              detail.page_view < 1 ? 0 : Math.round((detail.calculate / detail.page_view) * 1e2) / 1e2;
          }

          viewList[index].list[rowNum] = detail;

          if (action.payload.type !== "memo" && action.payload.type !== "pay_date") {
            // 모든 정산 항목 합계 계산 함수

            // 총 CP 정산금
            total!.cp_settlement = calculateTotalResult(viewList, "settlement");

            // 총 추가정산금
            total!.add_settlement = calculateTotalResult(viewList, "add_settlement");

            // 최종합계
            total!.calculate = calculateTotalResult(viewList, "calculate");
          }
          state.contents[subTab].saveFlag = false;
        }
      } else {
        if (action.payload.value !== undefined) {
          if (action.payload.type === "memo") {
            state.contents[subTab].viewList![index].message = String(action.payload.value);
          } else {
            state.contents[subTab].viewList![index].pay_date = String(action.payload.value);
          }
        }
      }
    },
    rdxResetSaveFlag(state: ICalculate, action: PayloadAction<string>) {
      state.contents[action.payload].saveFlag = undefined;
    },
    rdxSetSaveFlag(state: ICalculate, action: PayloadAction<string>) {
      state.contents[action.payload].saveFlag = false;
    },
    rdxSetCalculateTaxRowUpdate(
      state: ICalculate,
      action: PayloadAction<{ subTab: string; type: string; id: number; value: string }>,
    ) {
      state.contents[action.payload.subTab].viewList.map(i => {
        if (i.user_id === action.payload.id) {
          action.payload.type === "tax"
            ? (i.tax_status = action.payload.value as taxStatus)
            : action.payload.type === "pay"
            ? (i.pay_status = action.payload.value as payStatus)
            : (i.approval_status = action.payload.value as approvalStatus);
        }
      });
    },

    //정산 리스트 저장 버튼 누름 여부 (정산내역발행 버튼은 저장버튼 누르고 나서 누를 수 있음)
    rdxSetCalculateSaveFlag(state: ICalculate, action: PayloadAction<boolean | undefined>) {
      if (action.payload !== undefined) {
        state.contents[state.subTab[state.activeTab!]].saveFlag = action.payload;
      } else {
        delete state.contents[state.subTab[state.activeTab!]].saveFlag;
      }
    },

    //음원영상, 파트너스 - 예상수익 페이지인포
    rdxSetExpectListPageInfo(state: ICalculate, action: PayloadAction<IPageInfo>) {
      state.expect.pageInfo = action.payload;
    },
    //음원영상, 파트너스 - 예상수익 그리드 리스트
    rdxSetExpectListData(state: ICalculate, action: PayloadAction<IExpectListVo[]>) {
      state.expect.list = action.payload;
    },

    //음원영상, 파트너스 - 정산금 페이지인포
    rdxSetSettlementListPageInfo(state: ICalculate, action: PayloadAction<IPageInfo>) {
      state.settlement.pageInfo = action.payload;
    },
    //음원영상, 파트너스 - 정산금 그리드 리스트
    rdxSetSettlementListData(state: ICalculate, action: PayloadAction<ISettlementListVo[]>) {
      state.settlement.list = action.payload;
    },
    //음원영상, 파트너스 - 정산금 / 엑셀 불러왔을때 보여질 리스트
    rdxSetSettlementExcelViewList(state: ICalculate, action: PayloadAction<ISettlementListVo[]>) {
      state.settlement.excelViewList = action.payload;
    },

    //정산 리스트 필터값 적용
    rdxSetViewListFilter(state: ICalculate, action: PayloadAction<{ subTab: string; type: string; value?: string }>) {
      if (action.payload.value) {
        state.contents[action.payload.subTab].viewList = state.contents[action.payload.subTab].list.filter(i => {
          const type = action.payload.type === "tax" ? i.tax_status : i.pay_status;
          return type === action.payload.value;
        });
      } else {
        state.contents[action.payload.subTab].viewList = state.contents[action.payload.subTab].list;
      }
    },

    // 리덕스 초기화

    //대분류 탭 초기화
    rdxResetActiveTab(state: ICalculate) {
      delete state.activeTab;
    },

    //예상수익 페이지 초기화
    rdxResetExpectListData(state: ICalculate) {
      state.expect.list = [];
      delete state.expect.pageInfo;
    },
    //정산금 페이지 초기화
    rdxResetSettlementListData(state: ICalculate) {
      state.settlement.list = [];
      delete state.settlement.pageInfo;
    },
    //정산금 엑셀 view 리스트 초기화
    rdxResetSettlementExcelViewList(state: ICalculate) {
      if (state.settlement.excelViewList) {
        delete state.settlement.excelViewList;
      }
    },
    //콘텐츠 - 정산금 페이지 초기화
    rdxResetCalculateGridData(state: ICalculate, action: PayloadAction<string>) {
      state.contents[action.payload].list = [];
      state.contents[action.payload].viewList = [];
      // delete state.contents[action.payload].detailList;
      delete state.contents[action.payload].info;
      delete state.contents[action.payload].total;
    },
  },
  extraReducers: builder => {
    // builder.addCase(apiPreportGridData.pending, state => {
    //   state.report = {
    //     ...state.report,
    //     isLoading: true,
    //   };
    // });
    // builder.addCase(apiPreportGridData.fulfilled, state => {
    //   state.report = {
    //     ...state.report,
    //     isLoading: false,
    //   };
    // });
    // builder.addCase(apiPcontentsGridData.pending, state => {
    //   state.contents!.isLoading = true;
    // });
    // builder.addCase(apiPcontentsGridData.fulfilled, state => {
    //   state.contents!.isLoading = false;
    // });
  },
});

// 리덕스 액션
export const {
  rdxSetActiveTab,
  rdxSetSearchMonthTab,
  rdxSetSubTab,
  rdxSetSelectChannelList,
  rdxRemoveSelectChannelList,

  //서브탭 예상수익
  rdxSetExpectListData,
  rdxSetExpectListPageInfo,

  //서브탭 정산금
  rdxSetSettlementListPageInfo,
  rdxSetSettlementListData,
  rdxSetSettlementExcelViewList,
  //정산 리스트(최초 진입)
  rdxSetCalculateGridListData,
  rdxSetCalculateGridRowUpdate,
  rdxSetCalculateGridTotalData,
  rdxSetCalculateTotalInfo,
  rdxSetCalculateSaveFlag,
  rdxSetCalculateTaxRowUpdate,

  rdxSetViewListFilter,

  //초기화 관련
  rdxResetExpectListData,
  rdxResetSettlementListData,
  rdxResetActiveTab,
  rdxResetCalculateGridData,
  rdxResetSettlementExcelViewList,
  rdxResetSaveFlag,
  rdxSetSaveFlag,
} = CalculateSlice.actions;

// 리덕스 리듀서
export default CalculateSlice.reducer;
